const SESSION_EXPIRY_DELAY_MS = 3 * 1000;

let logoutTimer;
let isPopupOpen = false;
const listeners = new Set();

const notifyPopupState = () => {
    listeners.forEach((listener) => listener(isPopupOpen));
};

export const subscribeToSessionExpiredPopup = (listener) => {
    listeners.add(listener);
    listener(isPopupOpen);

    return () => listeners.delete(listener);
};

export const completeSessionExpiredLogout = () => {
    clearTimeout(logoutTimer);
    logoutTimer = null;
    isPopupOpen = false;
    notifyPopupState();
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/login');
};

export const logoutAfterSessionExpiry = (beforeLogout) => {
    if (window.location.pathname === '/login' || logoutTimer) {
        return;
    }

    isPopupOpen = true;
    notifyPopupState();
    Promise.resolve(beforeLogout?.()).catch((error) => {
        console.error('Unable to complete session logout:', error);
    });

    logoutTimer = setTimeout(completeSessionExpiredLogout, SESSION_EXPIRY_DELAY_MS);
};
